/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import CommonVars from "../components/CommonVars";
import {
    Heading,
    Image,
    Flex,
    Button,
    Box,
    Grid,
    Text,
    useNumberInput,
    HStack,
    Input,
    Link,
    SimpleGrid,
    useToast,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Spinner,
    VStack
} from "@chakra-ui/react";
import axios from 'axios';
import { BsStar, BsStarFill, BsStarHalf, BsGraphUp } from 'react-icons/bs';
import { useParams } from "react-router-dom";

import {
    FaReddit,
    FaTwitter,
    FaCopy,
    FaFacebook
} from 'react-icons/fa'

import {
    TwitterButton,
    FacebookButton,
    RedditButton,
}
from 'react-social';

function ProductDetailsScreen() {
    const [productDetails, setProductsDetails] = useState('');
    const [reviewRating, setReviewRating] = useState('');
    const [loading, setLoading] = useState(false);

    const productid = useParams().productid;

    const pageUrl = window.location.href;

    // Copy product link to clipboard for sharing
    const copyLink = async () => {
        await navigator.clipboard.writeText(window.location.href);
        if (!toast.isActive(id)) {
            toast({
                id,
                description: "Product link copied to your clipboard!",
                status: 'success',
                position: 'top',
                duration: 3000,
                isClosable: true,
            });
        };
    };

    // access backend to retrieve total and average rating
    const getReviewSummary = async () => {
        axios.get(`${CommonVars.API_URL}/product/${productid}/review-summary`)
        .then((res) => {
            console.log(res);
            if (res.data[0] === undefined) {
                setReviewRating(0);
            } else {
                setReviewRating(res.data[0]);
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    // get products by Id from server
    const getProductById = async () => {
        axios.get(`${CommonVars.API_URL}/products/${productid}`)
        .then((res) => {
            setLoading(true);
            console.log(res.data);
            setProductsDetails(res.data);
        })
        .catch((err) => {
            console.log(err);   
        });
    };

    function Rating({ rating, numReviews, productid }) {
        if(numReviews === undefined){
            numReviews = 0;
        }

        return (
          <Flex alignItems="center" mb="30px">
            {Array(5)
              .fill('')
              .map((_, i) => {
                const roundedRating = Math.round(rating * 2) / 2;
                if (roundedRating - i >= 1) {
                    return (
                        <BsStarFill
                            key={i}
                            style={{ marginLeft: '1' }}
                            color={i < rating ? 'teal.500' : 'gray.300'}
                            size={14}
                        />
                    );
                }
                if (roundedRating - i === 0.5) {
                    return <BsStarHalf key={i} size={14} style={{ marginLeft: '1' }} />;
                }
                return <BsStar key={i} size={14} style={{ marginLeft: '1' }} />;
              })}
            <Box as="span" ml="2" color="gray.600" fontSize="0.8rem">
                <a href={'/product/' + productid + '/reviews'}>{numReviews} review{numReviews > 1 && 's'}</a>
            </Box>
          </Flex>
        );
    }

    const { getInputProps, getIncrementButtonProps, getDecrementButtonProps } =
        useNumberInput({
        step: 1,
        defaultValue: '',
        min: 1,
        max: 20,
    });

    const inc = getIncrementButtonProps();
    const dec = getDecrementButtonProps();
    const input = getInputProps();

    useEffect(() => {
        getProductById();
        getReviewSummary();
    }, []);

    // set toast
    const toast = useToast();
    const id = 'pdtDetails-toast';

    // for modal
    const { isOpen, onOpen, onClose } = useDisclosure();

    // get user details from local storage
    const pdtUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    let pdtUserRole = '';
    if(pdtUserDetails !== null) {
        pdtUserRole = pdtUserDetails.role;
    }
   
    // get token from local storage
    const Token = localStorage.getItem('token');

    const handleSubmit = (e) => {
        e.preventDefault();

            // check if user is logged in to add product
            if (pdtUserDetails == null) {
                window.location.href = '/login';
            }

            const apuserid = pdtUserDetails.userid;
            // retrieve number in qty field
            const acquantity = input.value;

            // if acquantity = null, alert user to input some values
            // eslint-disable-next-line eqeqeq
            if (acquantity == false) {
                // alert('Enter the quantity you would like for the product');
                if (!toast.isActive(id)) {
                    toast({
                        id,
                        title: 'Quantity!',
                        description: "Enter the quantity you would like for the product",
                        status: 'error',
                        position: 'top',
                        duration: 2000,
                        isClosable: true,
                    });
                };
            } else {
                // prepare requestBody to post item to the users cart
                const addToCartRequestBody = {
                    productid: productid,
                    quantity: acquantity,
                };

                // access backend to post item into the users cart
                axios.post(`${CommonVars.API_URL}/carts/${apuserid}`, addToCartRequestBody, 
                    { headers: { Authorization: `Bearer ${Token}` } 
                })
                    .then(() => {
                        if (!toast.isActive(id)) {
                            toast({
                                id,
                                title: 'Success!',
                                description: "Item successfully added to cart!",
                                status: 'success',
                                position: 'top',
                                duration: 3000,
                                isClosable: true,
                            });
                        };

                        setTimeout(() => {
                            window.location.href = '/products';
                        }, 1000);
                    })
                    .catch((error) => {
                        console.log(error);
                        if (!toast.isActive(id)) {
                            toast({
                                id,
                                title: 'Cancelled!',
                                description: "Add to cart cancelled!",
                                status: 'success',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        };
                    });
            };
    };

    const redirect = () => {
        window.location.replace(`/products/${productid}/update-product`);
    }

    const deleteProduct = (e) => {
        e.preventDefault();
        
        axios.delete(`${CommonVars.API_URL}/products/${productid}`,
            { headers: { Authorization: `Bearer ${Token}` } }
        )
            .then(() => {
                if (!toast.isActive(id)) {
                    toast({
                        id,
                        title: 'Success!',
                        description: "Product Successfully Deleted!",
                        status: 'success',
                        position: 'top',
                        duration: 3000,
                        isClosable: true,
                    });
                };
                setTimeout(() => {
                    window.location.replace('/products');
                }, 2000);
            })
            .catch((error) => {
                console.log(error);
                if (!toast.isActive(id)) {
                    toast({
                        id,
                        title: 'Error!',
                        description: "Some error occurred while deleting Product!",
                        status: 'error',
                        position: 'top',
                        duration: 2000,
                        isClosable: true,
                    });
                };
            });
    }

    const aProductDetails = [];

    const review = [];

    for(var i = 0; i < reviewRating.length; i++){
        review.push(
            reviewRating[i]
        );
    };

    aProductDetails.push(
        <Box
            key={productid}
            borderWidth="1px"
            rounded="lg"
            shadow="lg"
            position="relative"
            py="6"
            bgColor={"whiteAlpha.600"}
        >
            <Flex justifyContent="space-around" py="5">
                <SimpleGrid
                    columns={{ lg: 1, xl: 2}}
                    columnGap={{ base: 4, md: 6 }}
                    rowGap={{ base: 8, md: 10 }}
                >
                    <Image
                        boxSize="400px"
                        src={productDetails.products_img_url}
                        alt={`Picture of ${productDetails.name}`}
                        rounded="lg"
                        mx={{ lg: "auto"}}
                        shadow="md"
                    />
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        pr="10"
                    >
                        <Rating rating={reviewRating.averagerating} numReviews={reviewRating.totalreviews} productid={productid} />
                        <Text>
                            {productDetails.categoryname}
                        </Text>
                        <Heading mt="4">{productDetails.name}</Heading>
                        <Text mt="4">${productDetails.price}</Text>

                        <Flex mt="4">
                            <HStack maxW='200px' mr="7">
                                <Button
                                    border={'1px'}
                                    bg = 'white'
                                    color = 'black'
                                    _hover = {{
                                        bg: 'black',
                                        color: 'white',
                                        border: '2px solid black'
                                    }}
                                    {...dec}
                                >-</Button>
                                <Input
                                    textAlign="center"
                                    focusBorderColor='black'
                                    placeholder="0"
                                    {...input}
                                />
                                <Button
                                    border={'1px'} 
                                    bg = 'white'
                                    color = 'black'
                                    _hover = {{
                                        bg: 'black',
                                        color: 'white',
                                        border: '2px solid black'
                                    }}
                                    {...inc}
                                >+</Button>
                            </HStack>
                            <Button
                                onClick={onOpen}
                                w="150px"
                                bg = 'black'
                                border={'1px'}
                                color = 'white'
                                _hover = {{
                                    bg: 'white',
                                    color: 'black',
                                    border: '2px solid black'
                                }}
                            >
                                Add To Cart
                            </Button>
                            <Modal isOpen={isOpen} onClose={onClose} size={'sm'}>
                            <ModalOverlay />
                            <ModalContent>
                                <ModalHeader>Add item</ModalHeader>
                                <ModalCloseButton />
                                <ModalBody>
                                    Do you want to add {productDetails.name} to cart?
                                </ModalBody>

                                <ModalFooter>
                                    <Button 
                                        border={'2px'}
                                        bg = 'white'
                                        color = 'black'
                                        _hover = {{
                                            bg: 'black',
                                            color: 'white',
                                            border: '2px solid black'
                                        }}mr={3} onClick={onClose}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                    type="submit"
                                    border={'1px'} 
                                    bg = 'black'
                                    color = 'white'
                                    _hover = {{
                                        bg: 'white',
                                        color: 'black',
                                        border: '2px solid black'
                                    }}
                                    onClick={handleSubmit}>Add</Button>
                                </ModalFooter>
                            </ModalContent>
                            </Modal>
                        </Flex>
                        <Box mt="4">
                            <Text fontWeight="bold">Description</Text>
                            <Text>{productDetails.description}</Text>
                        </Box>

                        {/* Product sharing */}
                        <Text mt = "3rem">Share this Product!</Text>
                        <HStack>
                            <Grid w = '50%' templateColumns='repeat(6, 1fr)' mt = '.5rem'>
                            
                                {/* Facebook */}
                                <FacebookButton
                                    url = {'ades-team-4-ca1-netlify.app'}
                                    appId = {1104122630482397}
                                    message = {'Check out this awesome product from WLD Watches!'}
                                >
                                    <FaFacebook size={25}/>
                                </FacebookButton>

                                {/* Twitter */}
                                <TwitterButton
                                    url={pageUrl}
                                    message = {"Check out this awesome product from WLD Watches!"}
                                >
                                    <FaTwitter size={25}/>
                                </TwitterButton>

                                {/* Reddit */}
                                <RedditButton
                                    url = {pageUrl}
                                    title = {'Check out this awesome product from WLD Watches!'}
                                >
                                    <FaReddit size={25} />
                                </RedditButton>

                                {/* Copy the link to clipboard */}
                                <FaCopy
                                onClick = {copyLink}
                                cursor = "pointer"
                                size={25} />
                            </Grid>

                            {/* Only Admin can see */}
                            {pdtUserRole !== 'admin' ?
                                null :
                                <>
                                    <Button 
                                        type={"submit"}
                                        onClick={redirect}
                                        bg = 'black'
                                        color = 'white'
                                        _hover = {{
                                            bg: 'white',
                                            color: 'black',
                                            border: '2px solid black'
                                        }}
                                    >
                                        Update
                                    </Button>
                                    <Button 
                                        type={'submit'}
                                        onClick={deleteProduct}
                                        bg = 'black'
                                        color = 'white'
                                        _hover = {{
                                            bg: 'white',
                                            color: 'black',
                                            border: '2px solid black'
                                        }}
                                    >
                                        Delete
                                    </Button>
                                    <Link href={`/data-visuals/product/${productid}`}>
                                        <Button
                                            bg = 'black'
                                            color = 'white'
                                            _hover = {{
                                                bg: 'white',
                                                color: 'black',
                                                border: '2px solid black'
                                            }}
                                        >
                                            <BsGraphUp />
                                        </Button>
                                    </Link>  
                                </>
                            }
                        </HStack>
                    </Box>
                </SimpleGrid>
            </Flex>
        </Box>
    )

    return (
        <Flex 
            minH={'70vh'}
            justify={'center'}
            bg={'#F4F4F4'}
        >
            {
                loading !== true ? 
                <Flex align={'center'} justify={'center'}>
                    <VStack align="center">
                            <Spinner thickness='9px' speed='0.75s' emptyColor='gray.200' color='blue.500' boxSize={24}/>
                            <Text fontSize={18} pt={6}>Loading Product...</Text>
                    </VStack>
                </Flex> : 
                <>
                    <Box
                        px={{
                            base: '8',
                            md: '10rem',
                            lg: '12rem'
                        }}
                        py={{
                            base: '6',
                            md: '8',
                            lg: '12'
                        }}
                    >
                        {aProductDetails}
                    </Box>
                </>
            }
        </Flex>
    )
}

export default ProductDetailsScreen;